module.exports = __webpack_public_path__ + "static/media/download_white.15eb93c3.png";